import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldCheck } from "@fortawesome/pro-regular-svg-icons";
import { DefaultFormModal } from "../DefaultFormModal";
import { TokenUserEvents } from "~/modules/analytics/events/tokens";

export function ConfidentialNetworkNotice(props: {
    networkName: string;
    context: "holders" | "transactions";
}) {
    const { networkName, context } = props;

    const contextText =
        context === "holders"
            ? "Holder addresses"
            : "Transaction hashes and participant addresses";

    return (
        <div className="flex flex-col items-center justify-center px-12 py-16 text-center text-slate-400">
            <FontAwesomeIcon
                icon={faShieldCheck}
                className="mx-auto h-12 w-12"
                aria-hidden="true"
            />
            <p className="mt-4 block text-lg font-medium text-slate-500">
                Confidential Network
            </p>
            <p className="mt-3 block max-w-sm text-base font-light">
                {networkName} uses confidential transactions. {contextText} are
                not publicly available.
            </p>
            <p className="mt-4 block text-sm font-light">
                <DefaultFormModal
                    title="Contact the team"
                    body="Get in touch about this asset or to connect with the issuer. We are also available at team@rwa.xyz and usually respond within 24 hours."
                    buttonText="Contact us"
                    buttonClassName="text-link hover:text-link-hover underline underline-offset-4"
                    analyticsLabel={
                        TokenUserEvents.OpenConfidentialNetworkContactModal
                    }
                    analyticsEventProperties={{
                        networkName,
                        context,
                    }}
                />{" "}
                to get in touch with the issuer for more information.
            </p>
        </div>
    );
}

export function ConfidentialNetworkBanner(props: { networkName: string }) {
    const { networkName } = props;

    return (
        <div className="flex items-center gap-2.5 border-b bg-slate-50/60 px-4 py-2.5">
            <FontAwesomeIcon
                icon={faShieldCheck}
                className="h-4 w-4 shrink-0 text-slate-400"
                aria-hidden="true"
            />
            <p className="text-sm text-slate-500">
                <span className="font-medium text-slate-600">
                    Confidential Network
                </span>
                <span className="mx-1.5 text-slate-300">·</span>
                {networkName} uses confidential transactions. Transaction hashes
                and participant addresses are not publicly available.
            </p>
        </div>
    );
}
